import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, getThemeTokens } from '../tokens';

export const styledBackstageInfoCard = (
  theme: Theme,
): BackstageOverrides['BackstageInfoCard'] => {
  const tokens = getThemeTokens(theme);

  return {
    header: {
      backgroundColor: getSurfaceColor(theme, 'subtle'),
      borderBottom: `1px solid ${getSurfaceBorder(theme)}`,
      padding: theme.spacing(2.5, 3),
    },
    headerTitle: {
      color: tokens.textPrimary,
      fontSize: theme.typography.h6.fontSize,
      fontWeight: 700,
    },
    headerSubheader: {
      color: tokens.textMuted,
      fontSize: theme.typography.body2.fontSize,
    },
    headerContent: {
      gap: theme.spacing(0.5),
    },
    headerAction: {
      alignSelf: 'center',
    },
  };
};
